import { Params, Query } from 'redux-little-router';
import { createSelector } from 'reselect';

import { SwitchOnAutotargetingKey } from '../declarations/switchOnAutotargetingRecommendations/switchOnAutotargetingRecommendations';
import { castStringToEnum } from '../service/CastHelpers';
import { getRecommendationAgregatorTitle } from '../service/RecommendationsHelpers/RecommendationsHelpers';
import { UrlHelpers } from '../service/UrlHelpers';
import { GridViewType, SortDirection } from '../typings/grid';
import {
    EditPageRecommendationsData,
    RecommendationCharacter,
    RecommendationsAgregator,
    RecommendationsItemsScreenUrlSearchParams,
    RecommendationType
} from '../typings/recommendations';
import { State } from '../typings/state';

export const selectRecommendationItemsSortParams = createSelector(
    (state: State) => state.router.query || {},
    (state: State) => state.router.params || {},
    (query: Query, params: Params) => {
        const recommendationType = castStringToEnum(params.type, RecommendationType);

        const sortKey = query[RecommendationsItemsScreenUrlSearchParams.sortKey];
        const sortDirection = query[RecommendationsItemsScreenUrlSearchParams.sortDirection];

        const sortParams = {
            [RecommendationType.dailyBudget]: {
                key: 'name',
                direction: SortDirection.asc
            },
            [RecommendationType.switchOnAutotargeting]: {
                key: SwitchOnAutotargetingKey.CLICKS_FORECAST,
                direction: SortDirection.desc
            }
        }[recommendationType];

        return UrlHelpers.normalizeSortParams(sortKey, sortDirection, undefined, sortParams);
    }
);

export const getRecommendationAgregatorData = (
    recommendationSet: EditPageRecommendationsData,
    view: GridViewType
): RecommendationsAgregator => {
    if (!recommendationSet) {
        return {
            isRecommendationsVisible: false
        };
    }

    const { recommendations, isRecommendationsVisible } = recommendationSet;
    const recommendationsCount = recommendations.length;

    if (recommendationsCount > 1) {
        const isCharacterAttention = recommendations.every(
            ({ character }) => character === RecommendationCharacter.attention
        );

        return {
            isRecommendationsVisible: isRecommendationsVisible,
            title: getRecommendationAgregatorTitle(recommendations.length, view),
            character: isCharacterAttention ? RecommendationCharacter.attention : RecommendationCharacter.warning
        };
    }

    return {
        isRecommendationsVisible: isRecommendationsVisible,
        recommendation: recommendations[0]
    };
};
